

































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Store from "@/store/modules/CpStore";
import Service from "@/services/Cp";
import {
  CpActivity,
  CpBarisMatriks,
  CpGrupSeksi,
  CpHari,
  CpLegendaItem,
  CpPathway,
  CpPeranTtd,
  CpSession
} from "@/types/cp";
import {
  DAMPAK_LABELS,
  HARI_LABELS,
  KATEGORI_VARIANCE_LABELS,
  STATUS_LABELS,
  glyphOf,
  glyphUntukStatus,
  grupkanMatriks,
  keDate,
  keTeksDateTime,
  labelBaris,
  selPertama
} from "@/utils/cp";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import { userModule } from "@/store/modules/user";

const LAIN = -1;

@Component({
  components: { VCDateTimePicker, UnitRuangPicker },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CpBlankoPage extends Vue {
  @Prop({ required: true }) registerId!: number;
  @Prop({ required: true }) pasienRm!: string;
  @Prop({ default: undefined }) unitId?: string;
  @Prop({ type: Boolean, default: false }) isActive!: boolean;

  store = Store;

  LAIN = LAIN;
  varDialog = false;
  hapusDialog = false;
  catatanDialog = false;
  catatanTarget: CpActivity | null = null;
  catatanText = "";

  newForm: Record<string, any> = {
    pathway_kode: null,
    masuk_at: null,
    rencana_rawat_hari: null,
    ruang_rawat: null,
    kelas: null
  };

  blanko: Record<string, any> = {};

  saran: Record<string, any> = {};
  saranApplied = false;

  newVar: Record<string, any> = {
    hari: null,
    kategori: "provider",
    activity_id: null,
    deskripsi_bebas: "",
    alasan: "",
    dampak: "none",
    klasifikasi: "minor"
  };

  hariLabels = HARI_LABELS;
  statusLabels = STATUS_LABELS;
  kategoriLabels = KATEGORI_VARIANCE_LABELS;
  dampakLabels = DAMPAK_LABELS;
  glyphOf = glyphOf;
  glyphUntukStatus = glyphUntukStatus;

  statusItems = (Object.keys(STATUS_LABELS) as (keyof typeof STATUS_LABELS)[]).map(
    value => ({ value, text: STATUS_LABELS[value] })
  );
  kategoriItems = Object.entries(KATEGORI_VARIANCE_LABELS).map(([value, text]) => ({ value, text }));
  rujukanItems = [
    { value: true, text: "Ya" },
    { value: false, text: "Tidak" }
  ];
  dampakItems = [
    { value: "none", text: "Tidak ada" },
    { value: "minor", text: "Minor" },
    { value: "major", text: "Major" }
  ];
  klasifikasiItems = [
    { value: "minor", text: "Minor" },
    { value: "major", text: "Major" }
  ];

  get record(): CpSession | null {
    return this.store.current;
  }
  get pathways(): CpPathway[] {
    return this.store.pathways;
  }
  get pathway(): CpPathway | null {
    return this.record && this.record.pathway ? this.record.pathway : null;
  }
  get loading(): boolean {
    return this.store.loading;
  }
  get isLocked(): boolean {
    return !!(this.record && this.record.is_locked);
  }

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get isCreator(): boolean {
    const uid = userModule.user ? userModule.user.id : null;
    return !!(uid != null && this.record && Number(this.record.creator_user_id) === Number(uid));
  }

  get canDelete(): boolean {
    if (!this.record || this.readOnly) return false;
    return !this.isLocked || this.isCreator;
  }
  get statusLabel(): string {
    const m: Record<string, string> = {
      draft: "Draft",
      active: "Aktif",
      completed: "Selesai",
      signed: "Ditandatangani"
    };
    return this.record && this.record.status ? m[this.record.status] || this.record.status : "—";
  }

  get hariKolom(): CpHari[] {
    return this.record && this.record.hari_kolom ? this.record.hari_kolom : ["h1", "h2"];
  }
  get hariItems() {
    return this.hariKolom.map(h => ({ value: h, text: HARI_LABELS[h] }));
  }
  get legenda(): CpLegendaItem[] {
    return this.record && this.record.legenda ? this.record.legenda : [];
  }

  get grupSeksi(): CpGrupSeksi[] {
    const acts = this.record && this.record.activities ? this.record.activities : [];
    return grupkanMatriks(acts);
  }

  get varianceItems(): { value: number; text: string }[] {
    const items: { value: number; text: string }[] = [];
    this.grupSeksi.forEach(g => {
      g.baris.forEach(b => {
        this.hariKolom.forEach(h => {
          const a = b.sel[h];
          if (!a || a.penanda === "tanpa" || a.penanda === "varian") return;
          if (this.newVar.hari && a.hari !== this.newVar.hari) return;
          items.push({ value: a.id, text: labelBaris(b, h) });
        });
      });
    });
    items.push({ value: LAIN, text: "Lainnya (di luar matriks)" });
    return items;
  }

  get varianceValid(): boolean {
    if (this.newVar.activity_id == null) return false;
    if (this.newVar.activity_id === LAIN) {
      return !!(this.newVar.deskripsi_bebas || "").trim();
    }
    return true;
  }

  glyphClass(a: CpActivity | undefined): string {
    return a ? "g-" + a.status : "";
  }

  catatanBaris(baris: CpBarisMatriks): string {
    const teks: string[] = [];
    this.hariKolom.forEach(h => {
      const a = baris.sel[h];
      if (!a) return;
      const isi = a.status === "variance" ? a.variance_reason : a.catatan;
      if (isi) teks.push(HARI_LABELS[h] + ": " + isi);
    });
    return teks.join(" · ");
  }

  catatanVarian(baris: CpBarisMatriks): string {
    const a = selPertama(baris);
    return a && a.catatan ? a.catatan : "";
  }

  signed(peran: CpPeranTtd): boolean {
    const blok = this.record && this.record.sign ? this.record.sign[peran] : null;
    return !!(blok && blok.signed);
  }
  signColor(peran: CpPeranTtd): string {
    return this.signed(peran) ? "green" : "grey";
  }

  async mounted() {
    await this.store.loadPathways();
    if (this.registerId) {
      await this.store.loadByRegister(this.registerId);
      await this.muatSaran();
      this.hydrate();
    }
  }

  @Watch("isActive")
  async onActive(val: boolean) {
    if (val && this.registerId && !this.record) {
      await this.store.loadPathways();
      await this.store.loadByRegister(this.registerId);
      await this.muatSaran();
      this.hydrate();
    }
  }

  async muatSaran() {
    try {
      const res = await Service.lookupPatient(this.registerId);
      this.saran = res?.data ?? {};
    } catch {
      this.saran = {};
    }
    if (!this.record && !this.newForm.ruang_rawat && this.saran.unit_nama) {
      this.newForm.ruang_rawat = this.saran.unit_nama;
    }
  }

  terapkanSaran() {
    if (this.saranApplied) return;
    this.saranApplied = true;
    if (this.blanko.berat_badan == null && this.saran.berat_badan != null) {
      this.$set(this.blanko, "berat_badan", Number(this.saran.berat_badan));
    }
    if (this.blanko.tinggi_badan == null && this.saran.tinggi_badan != null) {
      this.$set(this.blanko, "tinggi_badan", Number(this.saran.tinggi_badan));
    }
    if (!this.blanko.ruang_rawat && this.saran.unit_nama) {
      this.$set(this.blanko, "ruang_rawat", this.saran.unit_nama);
    }
  }

  hydrate() {
    const rec = this.record;
    if (!rec) return;
    this.blanko = {
      masuk_at: keDate(rec.masuk_at),
      keluar_at: keDate(rec.keluar_at),
      rencana_rawat_hari: rec.rencana_rawat_hari,
      berat_badan: rec.berat_badan != null ? Number(rec.berat_badan) : null,
      tinggi_badan: rec.tinggi_badan != null ? Number(rec.tinggi_badan) : null,
      diagnosa_masuk_rs: rec.diagnosa_masuk_rs,
      penyakit_utama: rec.penyakit_utama,
      penyakit_utama_icd: rec.penyakit_utama_icd,
      penyakit_penyerta: rec.penyakit_penyerta,
      penyakit_penyerta_icd: rec.penyakit_penyerta_icd,
      komplikasi: rec.komplikasi,
      komplikasi_icd: rec.komplikasi_icd,
      tindakan: rec.tindakan,
      tindakan_icd: rec.tindakan_icd,
      dietary_counseling_icd: rec.dietary_counseling_icd,
      ruang_rawat: rec.ruang_rawat,
      kelas: rec.kelas,
      rujukan: rec.rujukan,
      varian_catatan: rec.varian_catatan
    };
    this.terapkanSaran();
  }

  pilihPathway(p: CpPathway) {
    this.newForm.pathway_kode = p.kode;
    this.newForm.rencana_rawat_hari = p.rencana_rawat_hari;
  }

  async createSession() {
    await this.store.save({
      pathway_kode: this.newForm.pathway_kode,
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.unitId,
      masuk_at: keTeksDateTime(this.newForm.masuk_at),
      rencana_rawat_hari: this.newForm.rencana_rawat_hari || null,
      ruang_rawat: this.newForm.ruang_rawat || null,
      kelas: this.newForm.kelas || null
    });
    this.hydrate();
  }

  async saveHeader() {
    if (this.readOnly || !this.record) return;
    await this.store.save({
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.unitId,
      masuk_at: keTeksDateTime(this.blanko.masuk_at),
      keluar_at: keTeksDateTime(this.blanko.keluar_at),
      rencana_rawat_hari: this.blanko.rencana_rawat_hari,
      berat_badan: this.blanko.berat_badan,
      tinggi_badan: this.blanko.tinggi_badan,
      diagnosa_masuk_rs: this.blanko.diagnosa_masuk_rs,
      penyakit_utama: this.blanko.penyakit_utama,
      penyakit_utama_icd: this.blanko.penyakit_utama_icd,
      penyakit_penyerta: this.blanko.penyakit_penyerta,
      penyakit_penyerta_icd: this.blanko.penyakit_penyerta_icd,
      komplikasi: this.blanko.komplikasi,
      komplikasi_icd: this.blanko.komplikasi_icd,
      tindakan: this.blanko.tindakan,
      tindakan_icd: this.blanko.tindakan_icd,
      dietary_counseling_icd: this.blanko.dietary_counseling_icd,
      ruang_rawat: this.blanko.ruang_rawat,
      kelas: this.blanko.kelas,
      rujukan: this.blanko.rujukan,
      varian_catatan: this.blanko.varian_catatan
    });
    this.hydrate();
  }

  async setStatus(a: CpActivity, status: string) {
    if (a.status === status) return;
    await this.store.updateActivity({
      activityId: a.id,
      status,
      variance_reason: a.variance_reason,
      catatan: a.catatan
    });
  }

  async simpanVarianBaris(baris: CpBarisMatriks, teks: string) {
    const a = selPertama(baris);
    if (!a) return;
    await this.store.updateActivity({
      activityId: a.id,
      status: a.status,
      variance_reason: a.variance_reason,
      catatan: teks
    });
  }

  async tandaiRutinSelesai(h: CpHari) {
    const ids: number[] = [];
    this.grupSeksi.forEach(g => {
      g.baris.forEach(b => {
        const a = b.sel[h];
        if (a && a.penanda === "rutin" && a.status === "not_started") {
          ids.push(a.id);
        }
      });
    });
    await this.store.bulkUpdateActivities({ activityIds: ids, status: "done" });
  }

  openCatatan(a: CpActivity) {
    this.catatanTarget = a;
    this.catatanText = (a.status === "variance" ? a.variance_reason : a.catatan) || "";
    this.catatanDialog = true;
  }

  async simpanCatatan() {
    const a = this.catatanTarget;
    if (!a) return;
    const isVariance = a.status === "variance";
    await this.store.updateActivity({
      activityId: a.id,
      status: a.status,
      variance_reason: isVariance ? this.catatanText : a.variance_reason,
      catatan: isVariance ? a.catatan : this.catatanText
    });
    this.catatanDialog = false;
    this.catatanTarget = null;
    this.catatanText = "";
  }

  bukaDialogVariance() {
    this.resetNewVar();
    this.varDialog = true;
  }

  onPilihBaris(id: number | null) {
    if (id == null || id === LAIN) return;
    const acts = this.record && this.record.activities ? this.record.activities : [];
    const found = acts.filter(a => a.id === id)[0];
    if (found) {
      this.newVar.hari = found.hari;
    }
  }

  async submitVariance() {
    const pilihan = this.varianceItems.filter(i => i.value === this.newVar.activity_id)[0];
    const isLain = this.newVar.activity_id === LAIN;
    await this.store.addVariance({
      activity_id: isLain ? null : this.newVar.activity_id,
      hari: this.newVar.hari,
      kategori: this.newVar.kategori,
      deskripsi: isLain ? this.newVar.deskripsi_bebas : pilihan ? pilihan.text : "",
      alasan: this.newVar.alasan,
      dampak: this.newVar.dampak,
      klasifikasi: this.newVar.klasifikasi
    });
    this.varDialog = false;
    this.resetNewVar();
  }

  resetNewVar() {
    this.newVar = {
      hari: null,
      kategori: "provider",
      activity_id: null,
      deskripsi_bebas: "",
      alasan: "",
      dampak: "none",
      klasifikasi: "minor"
    };
  }

  async removeVariance(id: number) {
    await this.store.removeVariance(id);
  }

  async sign(peran: CpPeranTtd) {
    await this.store.sign(peran);
  }

  async hapusSession() {
    await this.store.removeSession();
    this.hapusDialog = false;
    this.blanko = {};
    this.newForm = {
      pathway_kode: null,
      masuk_at: null,
      rencana_rawat_hari: null,
      ruang_rawat: null,
      kelas: null
    };
  }

  printPdf() {
    if (this.record && this.record.id) Service.printPdf(this.record.id);
  }
}
